export const externalTypeToTemplateCountry = (externalType: string | undefined): 'IRELAND' | 'UK' | 'EU' => {
    if (externalType === 'REVENUE') return 'IRELAND';
    if (externalType === 'ICS2') return 'EU';
    return 'UK';
};

export const declarationExternalTypeToCountry = (externalType: string | undefined) => {
    switch (externalType) {
        case 'REVENUE':
            return 'Ireland';
        case 'CDS':
        case 'HMRC':
            return 'UK';
        case 'ICS2':
            return 'EU';
        default:
            return '';
        // throw new Error(`Can not parse external type to country: Value = ${externalType}`);
    }
};
